import { useQuery } from "@tanstack/react-query";
import { resourceReqService } from "../api/resourceReq";

export const useGetResourceReqDetails = ({ projectId, requestId }: { projectId: string | undefined, requestId: string | null }) => {

    const { data, isFetching, isPending, isError, error, isSuccess, refetch } = useQuery({
        queryKey: ["resource-requests-listing", projectId, requestId],
        queryFn: () => resourceReqService.getResourceReqById({ projectId, requestId }),
        enabled: !!projectId && !!requestId,
    });

    return {
        data: isSuccess ? data.data : null,
        isFetching,
        isPending,
        isError,
        error,
        refetch
    }

};